import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Login from "./views/pages/Login";
import Home from "./views/pages/Home";

// รายงาน
import Reports from "./views/pages/Reports";
import SalesReport from "./views/pages/Reports/SalesReport";
import InventoryMovementReport from "./views/pages/Reports/InventoryMovementReport";
import StockBalanceReport from "./views/pages/Reports/StockBalanceReport";
import LoanCrateReport from "./views/pages/Reports/LoanCrateReport";
import DepositReport from "./views/pages/Reports/DepositReport";
import OverdueLoanCrateReport from "./views/pages/Reports/OverdueLoanCrateReport";
import ReceivablesReport from "./views/pages/Reports/ReceivablesReport";
import PayablesReport from "./views/pages/Reports/PayablesReport";
import VansaleReport from "./views/pages/Reports/VansaleReport";

// จัดซื้อสินค้า
import Purchase from "./views/pages/Purchase";
import DepositDocument from "./views/pages/Purchase/DepositDoc";
import PurchaseRequest from "./views/pages/Purchase/PurchaseRequest";
import PurchaseOrder from "./views/pages/Purchase/PurchaseOrder";
import ProductReceipt from "./views/pages/Purchase/ProductReceipt";
import PaymentVoucher from "./views/pages/Purchase/PaymentVoucher";

// คลังสินค้า
import Warehouse from "./views/pages/Warehouse";
import WarehouseStock from "./views/pages/Warehouse/WarehouseStock";
import TreasuryDocuments from "./views/pages/Warehouse/TreasuryDocuments";

// ใบยืม-ใบเบิก
import BorrowWithdrawal from "./views/pages/BorrowWithdrawal";
import BillOfLading from "./views/pages/Warehouse/BillOfLading";
import Icebox from "./views/pages/Warehouse/Icebox";
import TechnicalEquipForm from "./views/pages/Warehouse/TechnicalEquipForm";
import OfficeEquipForm from "./views/pages/Warehouse/OfficeEquipForm";

// ขายสินค้า
import SellProducts from "./views/pages/SellProducts";
import Quotation from "./views/pages/SellProducts/Quotation";
import OrderProduct from "./views/pages/SellProducts/OrderProduct";
import BillOfSale from "./views/pages/SellProducts/BillOfSale";
import PickingList from "./views/pages/SellProducts/PickingList";

// งานบัญชี
import Account from "./views/pages/Account";
import PaymentStock from "./views/pages/Account/PaymentStock";
import Bill from "./views/pages/Account/Bill";
import Invoice from "./views/pages/Account/Invoice";
import Tax from "./views/pages/Account/Tax";

// ข้อมูลตั้งต้น
import InitialData from "./views/pages/InitialData";
import Creditor from "./views/pages/InitialData/Creditor";
import Debtor from "./views/pages/InitialData/Debtor";
import Employee from "./views/pages/InitialData/Employee";
import TbSetItem from "./views/pages/InitialData/TbSetItem";
import TbSetAPType from "./views/pages/InitialData/TbSetAPType";
import TbSetARType from "./views/pages/InitialData/TbSetARType";
import Company from "./views/pages/InitialData/Company";
import Dept from "./views/pages/InitialData/TbSetDept";
import Position from "./views/pages/InitialData/TbSetPosition";
import Car from "./views/pages/InitialData/TbSetCar";
import TbSetTransType from "./views/pages/InitialData/TbSetTransType";
import TbSetDocType from "./views/pages/InitialData/TbSetDocType";
import TbSetItmBrand from "./views/pages/InitialData/TbSetItmBrand";

import PageTitleSetter from "./views/components/PageTitleSetter";
// import TbSetUnit from "./views/pages/InitialData/TbSetUnit";
// import TbSetWh from "./views/pages/InitialData/TbSetWh";

import TwoScreen from "./views/pages/Page2screen";


// 404
import NotFoundPage from "./views/pages/404";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isLoggedIn = localStorage.getItem("token");

root.render(
  <BrowserRouter>
    <ToastContainer position="top-right" />
    <PageTitleSetter />
    <Routes>
      {/* รายงาน */}
      <Route
        path="/reports"
        element={isLoggedIn ? <Reports /> : <Navigate to="/login" />}
      />
      <Route
        path="/sales-report"
        element={isLoggedIn ? <SalesReport /> : <Navigate to="/login" />}
      />
      <Route
        path="/inventory-movement-report"
        element={
          isLoggedIn ? <InventoryMovementReport /> : <Navigate to="/login" />
        }
      />
      <Route
        path="/stock-balance-report"
        element={isLoggedIn ? <StockBalanceReport /> : <Navigate to="/login" />}
      />
      <Route
        path="/loan-crate-report"
        element={isLoggedIn ? <LoanCrateReport /> : <Navigate to="/login" />}
      />
      <Route
        path="/deposit-report"
        element={isLoggedIn ? <DepositReport /> : <Navigate to="/login" />}
      />
      <Route
        path="/overdue-loan-crate-report"
        element={
          isLoggedIn ? <OverdueLoanCrateReport /> : <Navigate to="/login" />
        }
      />
      <Route
        path="/receivables-report"
        element={isLoggedIn ? <ReceivablesReport /> : <Navigate to="/login" />}
      />
      <Route
        path="/payables-report"
        element={isLoggedIn ? <PayablesReport /> : <Navigate to="/login" />}
      />
      <Route
        path="/vansale-report"
        element={isLoggedIn ? <VansaleReport /> : <Navigate to="/login" />}
      />

      {/* จัดซื้อสินค้า */}
      <Route
        path="/"
        element={isLoggedIn ? <Home /> : <Navigate to="/login" />}
      />
      <Route
        path="/purchase"
        element={isLoggedIn ? <Purchase /> : <Navigate to="/login" />}
      />
      <Route
        path="/deposit-document"
        element={isLoggedIn ? <DepositDocument /> : <Navigate to="/login" />}
      />
      <Route
        path="/purchase-request"
        element={isLoggedIn ? <PurchaseRequest /> : <Navigate to="/login" />}
      />
      <Route
        path="/purchase-order"
        element={isLoggedIn ? <PurchaseOrder /> : <Navigate to="/login" />}
      />
      <Route
        path="/product-receipt"
        element={isLoggedIn ? <ProductReceipt /> : <Navigate to="/login" />}
      />
      <Route
        path="/payment-voucher"
        element={isLoggedIn ? <PaymentVoucher /> : <Navigate to="/login" />}
      />

      {/* คลังสินค้า */}
      <Route
        path="/warehouse"
        element={isLoggedIn ? <Warehouse /> : <Navigate to="/login" />}
      />
      <Route
        path="/warehouse-stock"
        element={isLoggedIn ? <WarehouseStock /> : <Navigate to="/login" />}
      />
      <Route
        path="/treasury-documents"
        element={isLoggedIn ? <TreasuryDocuments /> : <Navigate to="/login" />}
      />

      {/* ใบยืม-ใบเบิก */}
      <Route
        path="/borrow-withdrawal"
        element={isLoggedIn ? <BorrowWithdrawal /> : <Navigate to="/login" />}
      />
      <Route
        path="/bill-of-lading"
        element={isLoggedIn ? <BillOfLading /> : <Navigate to="/login" />}
      />

      {localStorage.getItem("company") === "2" && (
        <>
          <Route
            path="/icebox"
            element={isLoggedIn ? <Icebox /> : <Navigate to="/login" />}
          />
        </>
      )}

      <Route
        path="/technical-equip-form"
        element={isLoggedIn ? <TechnicalEquipForm /> : <Navigate to="/login" />}
      />

      <Route
        path="/office-equip-form"
        element={isLoggedIn ? <OfficeEquipForm /> : <Navigate to="/login" />}
      />

      {/* ขายสินค้า */}
      <Route
        path="/sellProducts"
        element={isLoggedIn ? <SellProducts /> : <Navigate to="/login" />}
      />
      <Route
        path="/quotation"
        element={isLoggedIn ? <Quotation /> : <Navigate to="/login" />}
      />
      <Route
        path="/order-product"
        element={isLoggedIn ? <OrderProduct /> : <Navigate to="/login" />}
      />
      <Route
        path="/billofsale"
        element={isLoggedIn ? <BillOfSale /> : <Navigate to="/login" />}
      />
      <Route
        path="/picking-list"
        element={isLoggedIn ? <PickingList /> : <Navigate to="/login" />}
      />

      {/* งานบัญชี */}
      <Route
        path="/account"
        element={isLoggedIn ? <Account /> : <Navigate to="/login" />}
      />
      <Route
        path="/payment-stock"
        element={isLoggedIn ? <PaymentStock /> : <Navigate to="/login" />}
      />
      <Route
        path="/bill"
        element={isLoggedIn ? <Bill /> : <Navigate to="/login" />}
      />
      <Route
        path="/tax"
        element={isLoggedIn ? <Tax /> : <Navigate to="/login" />}
      />
      <Route
        path="/invoice"
        element={isLoggedIn ? <Invoice /> : <Navigate to="/login" />}
      />

      {/* ข้อมูลตั้งต้น */}
      <Route
        path="/initialdata"
        element={isLoggedIn ? <InitialData /> : <Navigate to="/login" />}
      />
      <Route
        path="/creditor"
        element={isLoggedIn ? <Creditor /> : <Navigate to="/login" />}
      />
      <Route
        path="/debtor"
        element={isLoggedIn ? <Debtor /> : <Navigate to="/login" />}
      />
      <Route
        path="/employee"
        element={isLoggedIn ? <Employee /> : <Navigate to="/login" />}
      />
      <Route
        path="/tbsetitem"
        element={isLoggedIn ? <TbSetItem /> : <Navigate to="/login" />}
      />

      {/* ข้อมูลตั้งต้น ใหม่ */}
      <Route
        path="/APtype"
        element={isLoggedIn ? <TbSetAPType /> : <Navigate to="/login" />}
      />

      <Route
        path="/ARtype"
        element={isLoggedIn ? <TbSetARType /> : <Navigate to="/login" />}
      />

      <Route
        path="/company"
        element={isLoggedIn ? <Company /> : <Navigate to="/login" />}
      />
      <Route
        path="/dept"
        element={isLoggedIn ? <Dept /> : <Navigate to="/login" />}
      />
      <Route
        path="/position"
        element={isLoggedIn ? <Position /> : <Navigate to="/login" />}
      />
      <Route
        path="/car"
        element={isLoggedIn ? <Car /> : <Navigate to="/login" />}
      />
      <Route
        path="/transType"
        element={isLoggedIn ? <TbSetTransType /> : <Navigate to="/login" />}
      />
      <Route
        path="/docType"
        element={isLoggedIn ? <TbSetDocType /> : <Navigate to="/login" />}
      />
      <Route
        path="/brand"
        element={isLoggedIn ? <TbSetItmBrand /> : <Navigate to="/login" />}
      />

      <Route path="/2screen" element={<TwoScreen />} />
      {/* <Route path="/3screen" element={<Screen3 />} /> */}

      {/* <Route
        path="/tb-set-unit"
        element={isLoggedIn ? <TbSetUnit /> : <Navigate to="/login" />}
      />
      <Route
        path="/tb-set-wh"
        element={isLoggedIn ? <TbSetWh /> : <Navigate to="/login" />}
      /> */}

      {/* Login */}
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </BrowserRouter>
);
